/**
 * TanStack Router: /workforce/payroll
 *
 * This route file was auto-generated by the route generation script.
 * Component: WorkforcePayrollPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import WorkforcePayrollPage from '@/app/workforce/payroll/page'

/**
 * Route: /workforce/payroll
 * Layout: _auth (authenticated)
 * Component: WorkforcePayrollPage
 */
export const Route = createFileRoute('/_auth/workforce/payroll')({
  component: WorkforcePayrollPage,
})
